import type { AdditionalSelectors } from '@makemydeal/dr-activities-customer-vehicles';
import { getActiveDeal } from '@makemydeal/dr-sales-checkin-store';

// selectors
import { isDealListCompareEnabled } from '@makemydeal/dr-shared-store/selectors/featureToggleSelectors';
import { getCustomerFirstName } from './selectors';

// activeDeal.details is the single source of truth for the active deal/version — every mutation
// path lands there. Deliberately not reading customerVehicles.selectedDeal*: a second copy of the
// same fact drifts, which is what used to break the Deal List's "current deal" highlight.
const getCurrentDealId = (state: any): string | undefined => getActiveDeal(state).dealId;

const getCurrentDealVersion = (state: any): string | undefined => getActiveDeal(state).dealStructure?.version;

export const additionalSelectors: AdditionalSelectors = {
    isDealListCompareEnabled,
    getCustomerFirstName,
    getCurrentDealId,
    getCurrentDealVersion
};
